import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'sl-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownComponent {
    title = input('');
    icon = input('more_vert');
}
